export default __webpack_public_path__ + "static/media/certs-5.c1804c9d.png";